// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
export const getCredentials = state => state.registerReducer.credential;
export const getErrors = state => state.registerReducer.errors;
